import AuthModel from '../models/authModel';
import { loginUtility } from '../../../core/js/index';
/**
 * Controller used for retrieval and storage of tokens
 */

//Check if token has been saved to model, if not request token through getToken
export function authenticate(){
    console.log('AuthController.authenticate');
    let authToken = AuthModel.authToken;

    if(typeof authToken !== 'undefined' && authToken.length > 0){
        return new Promise(function(resolve, reject) {
            resolve(AuthModel);
        });
    }
    else{
        return getSession();
    }
}

export function reauthenticate(){
    let reauthToken = AuthModel.reauthToken;

    console.log('reauthenticate()');

    if(typeof reauthToken !== 'undefined' && reauthToken.length > 0){
        return new Promise(function(resolve, reject){
            resolve(AuthModel);
        });
    }
    else{
        return getSession();
    }
}

//Return the value of param of AuthModel (should be the saved token)
export function get(param) {
    return AuthModel.get(param);
}
//Save the ssession data returned from service to Authmodel
export function saveSession(session){
    return AuthModel.saveSession(session);
}
//Send provided credentials to model method
function getSession() {
    return AuthModel.getSession();
}
